module.exports = __webpack_public_path__ + "static/img/pic8.240671a.png";


//////////////////
// WEBPACK FOOTER
// ./src/assets/pic8.png
// module id = /j68
// module chunks = 0